import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { getRewardProgress } from "../../core/APIService/apiService"
import ProgressBar from "../../components/ProgressBar/ProgressBar"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import TMHFooter from "../../components/TMHFooter/TMHFooter"
import "./RateTMHPage.scss"
import config from "../../config.json"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"
import useAuth from "../../core/Authentication/useAuth"
import { ReactComponent as Arrow1 } from "./images/arrow-1.svg"
import { ReactComponent as Arrow2 } from "./images/arrow-2.svg"
import { ReactComponent as Arrow3 } from "./images/arrow-3.svg"
import { ReactComponent as RightArrowCustom } from "./images/right-arrow-custom.svg"
import { ReactComponent as RightArrow } from "./images/right-arrow.svg"

export default function RateTMHPage() {
  useTitle("Rate Movie House - The Movie House TV")
  const auth = useAuth()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)
  const [progressPercent, setProgressPercent] = useState(0)
  const [error, setError] = useState("")
  // const [success, setSuccess] = useState("")
  const [showInsModal1, setShowInsModal1] = useState(false)
  const [verifyText, setVerifyText] = useState("")

  function handleReviewSubmitted() {
    setIsLoading(true)

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Token", auth.user?.token);
    myHeaders.append("Cache-Control", "no-cache");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch(config.baseUrl + "rate_movie_house_submitted", requestOptions)
      .then((response) => {
      return new Promise((resolve) => response.json()
        .then((json) => resolve({
          status: response.status,
          ok: response.ok,
          json,
        })))
      }).then(
          async (result) => {
            let json = result.json
            if (result.ok) {
              setVerifyText(json.message)
              setProgressPercent(await getRewardProgress(auth.user?.user_id))
            }
            else {
                setError(json.message)
            }
            setIsLoading(false)
          },
          (error) => {
            console.error(error)
            setError(error.toString())
            setIsLoading(false)
          }
      )
  }

  useEffect(() => {
    async function initData() {
      if (auth.isLogged()) {
        ReactGA.send("pageview")
        setProgressPercent(await getRewardProgress(auth.user?.user_id))
      } else {
        navigate("/login")
      }
    }

    initData()
  }, [auth, navigate])

  return (
    <>
      <TMHBanner classOption="only-gradient" isAuth styleId={2} navClass="profile-header">
        <div className="rate-tmh-wrapper">
        <div className="rate-tmh-background" />
          <div className="profile-nav">
            <div className="bar-wrapper">
              <div className="bar-text">
                <Arrow1 className="arrow-1" />
                Your live progress to a free new release movie
                <Arrow2 className="arrow-2" />
              </div>
              <ProgressBar percent={progressPercent} />
            </div>
            <div className={progressPercent === 100 ? "get-movie" : "get-movie-disabled"}>
              <div className="get-movie-text">
                Hit 100%?  Claim here
                <Arrow3 className="arrow-3" />
              </div>
              <button onClick={() => { if (progressPercent === 100) navigate("/request-coupon") }} className="get-movie-btn" >
                Get Your Free Movie
              </button>
            </div>
            <div className="nav-detail">
              My details
            </div>
            <button onClick={() => setShowInsModal1(!showInsModal1)} className="nav-inst">Instructions
              <span>
                <RightArrowCustom
                  fill="white"
                  width={14.09}
                  height={13.7}
                  style={showInsModal1 ? { marginLeft: "14px", transform: "rotate(90deg)" } : { marginLeft: "14px" }}
                />
              </span>
              {showInsModal1 && (
                <div className="nav-modal">
                  <div className="modal-container">
                    <a href="/tmh/#/install-direct" target="_blank">Install direct on my Roku Device</a>
                    <a href="/tmh/#/visit-roku-website" target="_blank">Use my account on Roku.com</a>
                  </div>
                </div>
              )}
            </button>
          </div>

          <div className="rate-tmh-page">
            <div className={progressPercent === 100 ? "block-get-movie" : "block-get-movie-disabled"} />
            <div className="title">Rate The Movie House</div>
            <ProgressBar percent={15} />
            <div className="des-list">
              <p style={{ "marginBottom": "25px" }}>
                Here are the steps to leaving us a 5 star review
              </p>
              <p>
                1. Go to the homepage of your Roku apps. <br />
                2. Find ‘The Movie House’ Roku app.<br />
                3. While hovering over it, click the * button on your Roku controller.<br />
                4. Now, scroll to the review area and give us a review.<br />
              </p>
              <p style={{ "marginTop": "20px", "marginBottom": "25px" }}>
              Once complete, click the “Review submitted” button below. We’ll verify and add 25% to your progress towards your next Free New Release Movie.
              </p>
              <div className="verify-section">
                <button style={verifyText!==""?{"marginLeft": "0"}:{}} onClick={handleReviewSubmitted} className="submit-btn" type="submit">
                  Review submitted
                </button>
                <div className="verify-text">{verifyText}</div>
              </div>

              <div style={{ color: "red" }}>{error}</div>
              {/* <div style={{ color: "green" }}>{success}</div> */}
              <div className="rate-note">
                Once verified your 25% will be applied
              </div>

              <div className="rate-tmh-nav" onClick={() => navigate('/profile')}>
                <RightArrow className="left-arrow" /> Back to dashboard
              </div>
            </div>
          </div>
          <TMHFooter />
        </div>

      </TMHBanner>
      {isLoading && <TMHLoader />}
    </>
  )
}